import React from "react";
import {
  MDBContainer,
  MDBInput,
  MDBCol,
  MDBRow,
  MDBSwitch,
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
} from "mdb-react-ui-kit";

import "./AccountEditModal.css";

import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import ParticipationEditor from "../ParticipationEditor/ParticipationEditor";

export class AccountEditModal extends React.Component {
  constructor(props) {
    super(props);

    let dataDefault = {
      IDCuenta: null,
      nombre: "",
      activo: 0,
      tipo: "PERSONAL"
    };

    // Convertir propietarios del formato MisCuentas al formato ParticipationEditor
    const propietarios = this.props.data.propietarios || [];
    const participaciones = propietarios.map((p) => {
      if (p.tipo === "CCON") {
        return {
          tipo: "CCON",
          IDUsuarioCCON: p.IDUsuarioCCON,
          nombre: p.nombre,
          email: p.email || null,
          participacion: p.participacion,
        };
      }
      return {
        tipo: "SSO",
        IDUsuario: p.IDUsuario,
        nombre: p.apodo || p.nombre || "Usuario",
        participacion: p.participacion,
      };
    });

    this.state = {
      showAccountEditModal: this.props.showAccountEditModal,
      data: Object.assign(dataDefault, this.props.data),
      enabled: this.props.data.activo,
      participaciones,
      usuariosCCON: [],
    };
  }

  componentDidMount() {
    this.getUsuariosCCON();
  }

  async getUsuariosCCON() {
    await doFetch("CCON", "getUsuariosCCON", null)
      .then((response) => response.json())
      .then((data) => {
        if (data.STATE === "SUCCESS") {
          this.setState({ usuariosCCON: data.DATA || [] });
        }
      })
      .catch(() => {});
  }

  closeModal() {
    this.props.onCloseModal();
  }

  closeModalStable = () => this.props.onCloseModal();

  handleChange(event) {
    let data = this.state.data;

    switch (event.target.id) {
      case "enabled":
        data["activo"] = this.state.enabled ? 0 : 1;
        this.setState(data);
        this.setState({enabled: !this.state.enabled});
        break;
      default:
        data[event.target.id] = event.target.value;
        this.setState(data);
        break;
    }
  }

  async doSave(event) {
    event.preventDefault();

    let res = await this.updateAccount();

    if (res) {
      this.props.onCloseModal();
    }
  }

  async updateAccount() {
    let result = false;

    this.props.onLoading(true);

    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        cuenta: this.state.data,
        participaciones: this.state.participaciones,
      }),
    };

    await doFetch("CCON", "updateAccountWithParticipations", requestOptions)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.STATE === "SUCCESS") {
          result = true;
        }
      })
      .catch((error) => {
        console.error(
          "Error al obtener datos:",
          JSON.stringify(error, null, 2)
        );
      })
      .finally(() => {
        this.props.onLoading(false);
      });

    return result;
  }

  setShow(event) {
    if (this.state.showAccountEditModal !== event) {
      if (!event) {
        this.props.onCloseModal();
      }
    }
  }

  render() {
    return (
      <>
        <MDBModal
          show={this.state.showAccountEditModal}
          onHide={this.closeModalStable}
          tabIndex="-1"
        >
          <MDBModalDialog size="lg">
            <MDBModalContent>
              <MDBModalHeader>
                <MDBModalTitle>{this.state.data.nombre}</MDBModalTitle>
                <MDBBtn
                  className="btn-close"
                  color="none"
                  onClick={() => this.closeModal()}
                ></MDBBtn>
              </MDBModalHeader>
              <MDBModalBody>
                <MDBContainer breakpoint="sm">
                <MDBRow>
                    <MDBCol size="8">
                      <MDBInput
                        className="mb-4"
                        type="text"
                        id="nombre"
                        label="Nombre de la cuenta"
                        value={this.state.data.nombre}
                        onChange={(event) => this.handleChange(event)}
                      />
                    </MDBCol>
                    <MDBCol size="2">
                      <select
                        id="tipo"
                        className="form-select mb-4"
                        value={this.state.data.tipo || "PERSONAL"}
                        onChange={(event) => this.handleChange(event)}
                      >
                        <option value="PERSONAL">Personal</option>
                        <option value="SHARED_EXPENSE">Gastos compartidos</option>
                        <option value="BUDGET">Presupuesto</option>
                      </select>
                    </MDBCol>
                    <MDBCol size="2">
                      <MDBSwitch
                        id="enabled"
                        label="Activo"
                        checked={this.state.enabled}
                        onChange={(event) => this.handleChange(event)}
                      />
                    </MDBCol>
                  </MDBRow>
                  <MDBRow>
                    <MDBCol size="12">
                      <label className="form-label">Participantes</label>
                      <ParticipationEditor
                        participaciones={this.state.participaciones}
                        usuariosCCON={this.state.usuariosCCON}
                        onChange={(p) => this.setState({ participaciones: p })}
                        onLoading={(v) => this.props.onLoading(v)}
                      />
                    </MDBCol>
                  </MDBRow>
                  <MDBBtn className="mt-3" onClick={(event) => this.doSave(event)} block>
                    Guardar
                  </MDBBtn>
                </MDBContainer>
              </MDBModalBody>
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>
      </>
    );
  }
}
